import React, { memo, useEffect, useState } from "react";
import moment from "moment";
import styles from "./Calendar.module.css";
import { getSessionStatus, toDateKey } from "./timeTableUtils";

const DailyTimetable = ({ data, date, isStaff }) => {
  const [currentTime, setCurrentTime] = useState(() => new Date());
  const hasRows = data.length > 0;

  // Update every minute so countdown stays live. The timer lives here so a tick
  // only re-renders this table, and it only runs while there are rows to update.
  useEffect(() => {
    if (!hasRows) return undefined;
    setCurrentTime(new Date());
    const timer = setInterval(() => setCurrentTime(new Date()), 60000);
    return () => clearInterval(timer);
  }, [hasRows]);

  const dateStr = toDateKey(date);
  const now = moment(currentTime);

  return (
    <div className={styles.tableWrapper}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>Period</th>
            <th>Time</th>
            <th>Subjects</th>
            {!isStaff && <th>Staff</th>}
            <th>Class</th>
            <th>Mode</th>
            <th>Session Starts in</th>
          </tr>
        </thead>
        <tbody>
          {hasRows ? (
            data.map((item, index) => (
              <tr key={index} className={index % 2 !== 0 ? styles.grayRow : ""}>
                <td>{item.period}</td>
                <td>
                  {item.break_start_time && item.break_end_time
                    ? `${item.break_start_time} - ${item.break_end_time}`
                    : "-"}
                </td>
                <td>{item.subject_name || "-"}</td>
                {!isStaff && <td>{item.staff_name || "-"}</td>}
                <td>
                  {item.class_name} - {item.section_id}
                </td>
                <td>
                  <span className={styles.classBadge}>Class</span>
                </td>
                <td>
                  {getSessionStatus(
                    item.break_start_time,
                    item.break_end_time,
                    dateStr,
                    now,
                  )}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={isStaff ? 6 : 7} style={{ textAlign: "center" }}>
                No Data Available
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default memo(DailyTimetable);
